import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NotificationSnackbar from './NotificationSnackbar';
import { removeNotification } from 'store/common/commonActions';

class NotificationSnackbarContainer extends React.Component {

    handleClose = (event, reason) => {
        
        if (reason !== 'clickaway') // === timeout
            this.props.removeNotification();
    }

    render()
    {
        const { notifications } = this.props;

        let notification = notifications && notifications.length > 0 ? notifications[0] : null;

        return (
            notification && (
                <NotificationSnackbar
                    open
                    key={notification.key}
                    onClose={this.handleClose}
                    message={notification.message}
                    importance={notification.importance}
                    closable={notification.closable}
                    url={notification.url}
                />
            )
        );

        //return (

        //    <React.Fragment>

        //    {
        //        notifications.map((notification, index) => (
        //            <NotificationSnackbar
        //                key={notification.key}
        //                open={notification.open}
        //                onClose={this.handleClose}
        //                message={notification.message}
        //                importance={notification.importance}
        //                closable={notification.closable}
        //                url={notification.url}
        //            />
        //        ))
        //    }

        //    </React.Fragment>
        //);
    }
}


NotificationSnackbarContainer.propTypes = {
    notifications: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
    //open: state.common.notification.open,
    //message: state.common.notification.message,
    //importance: state.common.notification.importance,
    //closable: state.common.notification.closable,
    //url: state.common.notification.url

    notifications: state.common.notifications
});

const mapDispatchToProps = dispatch => ({
    removeNotification: () => dispatch(removeNotification())
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSnackbarContainer);